import { SearchFigma } from '@components/SearchBars';
import styled from 'styled-components';

interface IContainer {
  offsetTop: number;
}

export const Container = styled.div<IContainer>`
  --offset-top: ${({ offsetTop }) => offsetTop}px;

  background: #fff;
  height: calc(100vh - var(--offset-top));
  padding: 40px;
  display: grid;
  grid-template-rows: auto auto 1fr;
`;

export const Head = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 34px;
`;

export const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: #1a1b1c;
`;

export const TabsContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
`;

export const Tabs = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
`;

interface isActiveProps {
  isActive?: boolean;
  isDisabled?: boolean;
}

export const Indicator = styled.div<isActiveProps>`
  height: 2px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: ${({ isActive }) => (isActive ? '#1371fe' : 'transparent')};
  z-index: 2;
`;

export const Back = styled.div`
  height: 1px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: #edeff4;
  z-index: 1;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;

  & + & {
    margin-left: 48px;
  }
`;

export const Count = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  height: 18px;
  padding: 0 6px;
  background: #edeff4;
  border-radius: 4px;
  margin-left: 10px;
  font-weight: 600;
`;

export const Label = styled.div`
  padding-right: 6px;
  padding-left: 6px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
`;

export const LabelText = styled.div<isActiveProps>`
  white-space: nowrap;
  font-size: 14px;
  color: ${({ isActive }) => (isActive ? '#1B203A' : '#696F8C')};
  opacity: ${({ isDisabled }) => (isDisabled ? '0.3' : 'unset')};
`;

interface IBody {
  show: boolean;
}

export const Body = styled.div<IBody>`
  display: ${({ show }) => (show ? 'block' : 'none')};

  background: #fff;
  width: 100%;
  height: 100%;

  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const FilterButton = styled.div`
  display: flex;
  margin-left: 8px;
  position: relative;
`;

export const Left = styled.div`
  display: flex;
  flex-direction: row;
`;

export const CreateButton = styled.button`
  display: flex;
  border: 1px solid #d8dae5;
  background-color: transparent;
  border-radius: 8px;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  padding-top: 5px;
  margin-left: 8px;

  :disabled {
    cursor: not-allowed;
  }
`;

export const UpdatesSearch = styled(SearchFigma)`
  width: 250px;
`;
